import { render, staticRenderFns } from "./itemtipoclasificacion-form.vue?vue&type=template&id=0af5f1a3&scoped=true"
import script from "./itemtipoclasificacion-form.vue?vue&type=script&lang=js"
export * from "./itemtipoclasificacion-form.vue?vue&type=script&lang=js"
import style0 from "./itemtipoclasificacion-form.vue?vue&type=style&index=0&id=0af5f1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5f1a3",
  null
  
)

export default component.exports